export default __webpack_public_path__ + "static/media/cartEmptySvg.d0f17020.svg";